<template>
    <div>
        <div class='searchBox'>
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="权限名称">
                    <el-input v-model="searchForm.mc" placeholder=""></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="resetSearch('searchForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class='btnsBox'>
            <el-button type="primary" @click="add">新增</el-button>
            <el-button type="primary" @click="del()" :disabled="multipleSelection.length==0">删除</el-button>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            row-key="id"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column type="index" label="序号" width="50">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="mc" label="权限名称"  width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="zy" label="资源"  min-width="170" show-overflow-tooltip :formatter="zyFormatter"></el-table-column>
            <el-table-column  label="操作" width="120" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
                    <el-button type="text"  @click='del(scope.row)'>删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="clear">
            <span class="lf pageNum">共{{total}}条。</span>
            <myPage
            class="rt"
            :total="total"
            :page-size="pageSize"
            :currentPage="currentPage"
            @changePage="changePage"
            ></myPage>
        </div>
        <!-- 新增编辑 -->
        <el-dialog :title='isEdit?"编辑权限":"新增权限"' :visible.sync="dialogVisible" width='700px' lock-scroll :close-on-click-modal="false">
            <el-form :model="form" ref='form' label-width="80px" :rules="formRules">
                <el-form-item label="名称" prop='mc'>
                    <el-input v-model="form.mc"></el-input>
                </el-form-item>
                <el-form-item label="资源" prop='zy'>
                    <el-checkbox-group v-model="form.zy">
                        <el-checkbox  v-for="item in zyOptions"  :key="item.id" :label='item.id'>{{item.mc}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='resetForm("form")'>重置</el-button>
                <el-button type="primary" @click='cancelForm("form")'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import myPage from '../../components/page'
export default {
    name:'',
    components:{
        myPage
    },
    props:[
        'adminLx'
    ],
    data(){
        return{
            searchForm:{
                mc:'',
            },
            tableData:[],
            total:0,
            pageSize:10,
            currentPage:1,
            multipleSelection:[],
            dialogVisible:false,
            isEdit:false,
            form:{
                mc:'',
                zy:[]
            },
            formRules:{
                name:[{required:true}],
                zy:[{required:true}],
            },
            zyOptions:[]
        }
    },
    methods:{
        getData(){
            let para=this.searchForm;
            para.currentPage=this.currentPage;
            para.pageSize=this.pageSize;
            para.lx=this.adminLx
            this.$api.getQxgl(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data;
                   this.zyOptions=res.data.data[0].zy;
                }
            }).catch(()=>{})
        },
        search(){
            this.currentPage=1;
            this.getData();
        },
        //重置
        resetSearch(formName) {
            this.$refs[formName].resetFields();
        },
        //新增
        add(){
            this.dialogVisible=true;
            this.isEdit=false;
            this.form={
                mc:'',
                zy:[]
            }
        },
        //编辑
        edit(row){
            this.dialogVisible=true;
            this.isEdit=true;
            let ids=[];
            row.zy.forEach(item=>{
                ids.push(item.id)
            })
            this.form={
                mc:row.mc,
                zy:ids
            }
        },
        saveForm(formName){

        },
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false
        },
        //删除
        del(row){
            let text=''
            let para={}
            if(row){
                text='确定要删除当前的权限吗？'
                para={
                    id:''
                }
            }else{
                text='确定要删除选中的权限吗？';
                para={
                    ids:''
                }
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            }).catch(() => {
                      
            });
        },
        changePage(val){
            this.currentPage=val;
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        zyFormatter(row, column, cellValue, index){
            let str=''
            if(row.zy.length==0){
                return ''
            }else{
                row.zy.forEach((item,index)=>{
                    if(index==row.zy.length-1){
                        str+=item.mc
                    }else{
                        str+=item.mc+','
                    }
                    
                })
                return str
            }
            
        }
    },
    mounted(){
        //this.getData();
    }
}
</script>  
<style lang="less" scoped>

</style>